"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TSalesOrderMessage = exports.googlePlayBadge = exports.appStoreBadge = exports.daysOfWeekMap = exports.humanTimeFormat = exports.humanDateFormat = exports.humanDateTimeFormat = exports.isoDateFormat = exports.defaultCharset = exports.colds = exports.hots = exports.OrderStates = exports.BumpPaths = exports.categories = exports.periods = void 0;
/**
 * quarterly period labels
 */
exports.periods = ["Next 15", "15-30", "30-45", "45-60"];
/**
 * menu categories
 * TODO: check if we don't have to hard code this
 */
exports.categories = {
    mains: "green",
    sides: "red",
    drinks: "blue",
    alcohol: "brown"
};
/**
 * bump route paths
 */
var BumpPaths;
(function (BumpPaths) {
    BumpPaths["Upcoming"] = "upcoming";
    BumpPaths["Preparing"] = "preparing";
    BumpPaths["Assembling"] = "assembling";
    BumpPaths["Ready"] = "ready";
    BumpPaths["PastOrders"] = "pastOrders";
})(BumpPaths = exports.BumpPaths || (exports.BumpPaths = {}));
/**
 * order states
 */
var OrderStates;
(function (OrderStates) {
    OrderStates["Current"] = "current";
    OrderStates["Other"] = "other";
    OrderStates["Ready"] = "ready";
})(OrderStates = exports.OrderStates || (exports.OrderStates = {}));
/**
 * hot products
 */
exports.hots = [
    "Chicken",
    "Mex Chicken",
    "Barbacoa Beef",
    "Pulled Pork",
    "Lamb",
    "Cauliflower",
    "White Rice",
    "Black Rice",
    "Pinto Beans",
    "Fried Chicken Breast"
];
/**
 * cold products
 */
exports.colds = [
    "Sour Cream",
    "Tomato Salsa",
    "Guacamole",
    "Vegan Cheese",
    "Apple Coleslaw"
];
exports.defaultCharset = "abcdefghijklmnopqrstuvwxyz0123456789";
exports.isoDateFormat = "YYYY-MM-DD";
exports.humanDateTimeFormat = "Do MMM YYYY h:mmA";
exports.humanDateFormat = "Do MMM YYYY";
exports.humanTimeFormat = "h:mmA";
exports.daysOfWeekMap = [
    [1, "Monday"],
    [2, "Tuesday"],
    [3, "Wednesday"],
    [4, "Thursday"],
    [5, "Friday"],
    [6, "Saturday"],
    [0, "Sunday"]
];
// images
exports.appStoreBadge = "https://dph95f73vdxmz.cloudfront.net/uploads/app-store.png";
exports.googlePlayBadge = "https://dph95f73vdxmz.cloudfront.net/uploads/google-play.png";
var TSalesOrderMessage;
(function (TSalesOrderMessage) {
    TSalesOrderMessage["CustomerNotFound"] = "Cannot update sales order status as the customer doesn't exist";
})(TSalesOrderMessage = exports.TSalesOrderMessage || (exports.TSalesOrderMessage = {}));
//# sourceMappingURL=constants.js.map